<template>
  <div style="width: 100%;position: relative;">
    <div class="topUploadDiv">
      <el-button @click="addAppendix" style="position: relative;left: 55%;"><i class="el-icon-upload2"></i> 上传附件
      </el-button>
    </div>
    <el-tabs :tab-position="tabPosition" style="min-height: 400px;" v-model="curTableIndex"
             v-loading="contentLoading"
             element-loading-text="正在处理..."
             element-loading-spinner="el-icon-loading"
             element-loading-background="rgba(0, 0, 0, 0.1)"
             v-if="this.appendixType.length > 0">
      <el-tab-pane v-for="(appendixTypeItem,key) in this.appendixType"
                   :key="appendixTypeItem.name"
                   :label="appendixTypeItem.name"
                   :name="key+''">
        <div style="width: 100%">
          <ul class="item-img-ul" v-if="appendixTypeItem.data.length > 0">
            <transition-group name="list" tag="ul">
              <li v-for="(item,key1) in appendixTypeItem.data" :key="item.id">
                <div class="outDiv">
                  <div class="outdiv-imgdiv" v-if="item.appendixType === 'PICTURE'">
                    <img v-bind:src="item.appendixUrl"/>
                    <span class="out-div-span">
                    <span class="out-div-span-view" @click="viewImg(item.appendixUrl)"><i
                      class="el-icon-zoom-in" title="预览"></i></span>
                    <span class="out-div-span-delete" v-if="item.appendixAudit === 0 || item.appendixAudit === 3" @click="deleteAppendix(item.id,key,key1)"><i
                      class="el-icon-delete" title="删除"></i></span>
                  </span>
                  </div>
                  <div class="outdiv-imgdiv" v-else>
                    <svg-icon v-if="item.appendixType === 'OTHER'" icon-class="file" class-name="svgClass"/>
                    <svg-icon v-if="item.appendixType === 'WORD'" icon-class="wordFile" class-name="svgClass"/>
                    <svg-icon v-if="item.appendixType === 'EXCEL'" icon-class="excelFile" class-name="svgExcelClass"/>
                    <svg-icon v-if="item.appendixType === 'PDF'" icon-class="pdfFile" class-name="svgClass"/>
                    <svg-icon v-if="item.appendixType === 'PPT'" style="fill: #d81e06" icon-class="pptFile"
                              class-name="svgClass"/>
                    <svg-icon v-if="item.appendixType === 'VEDIO'" icon-class="vedioFile" class-name="svgClass"/>
                    <svg-icon v-if="item.appendixType === 'VOICE'" icon-class="voiceFile" class-name="svgClass"/>
                    <span class="out-div-span">
                    <a class="out-div-span-view" v-bind:href="item.appendixUrl" v-bind:download="item.appendixCname"
                       target="_blank"><i class="el-icon-custom-xiazai" title="下载"></i></a>
                    <span class="out-div-span-delete" v-if="item.appendixAudit === 0 || item.appendixAudit === 3" @click="deleteAppendix(item.id,key,key1)"><i
                      class="el-icon-delete" title="删除"></i></span>
                  </span>
                  </div>
                  <el-tooltip class="item" effect="dark" v-bind:content="item.appendixCname" placement="left">
                    <span class="centerText">{{ item.appendixCname }}</span>
                  </el-tooltip>
                  <span class="auditLogo" v-show="item.appendixAudit === 0"><i
                    class="el-icon-custom-caogao"></i> </span>
                  <span class="auditingLogo" v-show="item.appendixAudit === 1"><i class="el-icon-custom-shenhe01"></i> </span>
                  <span class="auditedLogo" v-show="item.appendixAudit === 2"><i
                    class="el-icon-custom-shenhetongguo"></i> </span>
                  <span class="rejectLogo" v-show="item.appendixAudit === 3"><i
                    class="el-icon-custom-yinzhang-shenhebohui"></i> </span>
                  <span class="authOpreat">
                  <el-tooltip class="item" effect="dark" content="公开" placement="bottom">
                    <i
                      :class="[item.appendixAuthority === 'PUBLIC'?'el-icon-custom-gongkai public':'el-icon-custom-gongkai']"
                      @click="changAuth(item.id,item.appendixAuthority,'PUBLIC',key,key1)"></i>
                  </el-tooltip>
                  <el-tooltip class="item" effect="dark" content="不公开" placement="bottom">
                    <i
                      :class="[item.appendixAuthority === 'PUBLIC'?'el-icon-custom-bugongkai':'el-icon-custom-bugongkai public']"
                      @click="changAuth(item.id,item.appendixAuthority,'PROTECTED',key,key1)"></i>
                  </el-tooltip>
                </span>
                </div>
              </li>
            </transition-group>
          </ul>
          <div v-else>
            <svg-icon icon-class="noFile" class-name="svgClass"/>
          </div>
        </div>

      </el-tab-pane>

    </el-tabs>
    <div v-else>
      <svg-icon icon-class="noFile" class-name="svgClass"/>
    </div>
    <el-dialog :visible.sync="dialogImgVisible" size="tiny">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>

    <el-dialog :visible.sync="dialogUploadVisible">
      <div class="upload-top-div">附件类型：
        <el-select v-model="defaultType" filterable placeholder="请选择" @change="uploadTypeChange">
          <el-option
            v-for="item in appendixTypOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>

        附件属性：
        <el-select v-model="defaultProperties" filterable placeholder="请选择" @change="uploadPropertiesChange">
          <el-option
            v-for="item in appendixPropertiesOptions"
            :key="item.appendixEname"
            :label="item.appendixCname"
            :value="item.appendixEname">
          </el-option>
        </el-select>
      </div>
      <el-upload
        class="upload-demo"
        ref="topUpload"
        :action="uploadUrl"
        :on-preview="handlePreview"
        :on-remove="handleRemove"
        :before-upload="handleAppendixBefore"
        :on-success="handleAppendixSuccess"
        :headers="headerToken"
        :on-exceed="handleFullUpload"
        :file-list="fileList"
        :limit="1"
        :auto-upload="false">

        <el-button slot="trigger" size="small" round type="primary" style="color: white;border: none">选取文件</el-button>
        <el-button style="margin-left: 10px; color: white;border: none" round size="small" type="success"
                   @click="submitUpload">上传到服务器
        </el-button>
        <div slot="tip" class="el-upload__tip">{{ this.uploadComment }}</div>
      </el-upload>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getUserAppendix,
    deleteAppendix,
    getAppendixConfig,
    updateAppendixInfo,
    changeAppendixAuth
  } from '@/api/userInfo/userInfo'

  export default {
    name: "UserAppendix",
    props: {
      queryTypeText: String
    },
    mounted() {
      this.getUserAppendix();
    },
    data() {
      return {
        curTableIndex: '0',
        tabPosition: 'left',
        dialogImageUrl: '',
        dialogImgVisible: false,
        dialogUploadVisible: false,
        contentLoading: false,
        defaultType: 'PICTURE',
        defaultProperties: '',
        appendixPropertiesCname: '',
        uploadUrl: this.GLOBAL.apiBase + '/upload/ossFile',

        fileList: [],
        uploadComment: '只能上传jpg/png文件，且不超过3M',
        appendixTypOptions: [
          {value: 'PICTURE', label: '图片文件'},
          {value: 'WORD', label: 'word文件'},
          {value: 'EXCEL', label: 'excel文件'},
          {value: 'PDF', label: 'PDF文件'},
          {value: 'PPT', label: '幻灯片文件'},
          {value: 'VEDIO', label: '视频文件'},
          {value: 'VOICE', label: '音频文件'},
          {value: 'OTHER', label: '其他文件'}
        ],
        appendixPropertiesOptions: [],
        appendixType: [],
        appendixCount: 0
      }
    },
    computed: {
      headerToken() {
        return {
          'X-ACCESS-TOKEN': localStorage.getItem('userToken')
        }
      }
    },
    methods: {
      uploadTypeChange(){
        if(this.defaultType === 'PICTURE'){
          this.uploadComment = '只能上传jpg/png文件，且不超过3M';
        }else if(this.defaultType === 'WORD'){
          this.uploadComment = '只能上传.doc 和.docx文件,且不超过10M';
        }else if(this.defaultType === 'EXCEL'){
          this.uploadComment = '只能上传.xls 和.xlsx文件,且不超过10M';
        }else if(this.defaultType === 'PDF'){
          this.uploadComment = '只能上传.pdf文件,且不超过10M';
        }else if(this.defaultType === 'PPT'){
          this.uploadComment = '只能上传.ppt 和.pptx文件,且不超过10M';
        }else if(this.defaultType === 'VEDIO'){
          this.uploadComment = '只能上传.mp4  .avi .rmvb  .mov文件，且大小不能超过200M';
        }else if(this.defaultType === 'VOICE'){
          this.uploadComment = '只能上传.mp3，且大小不能超过20M';
        }else{
          this.uploadComment = '文件大小不能超过50M';
        }
      },
      uploadPropertiesChange(val){
        let obj = {};
        obj = this.appendixPropertiesOptions.find((item)=>{
          return item.appendixEname === val;
        });
        this.appendixPropertiesCname = obj.appendixCname;
      },
      viewImg(url) {
        this.dialogImageUrl = url;
        this.dialogImgVisible = true;
      },
      submitUpload() {
        this.$refs.topUpload.submit();
      },
      handleFullUpload(files,filelst){
        this.$message.warning('单次上传只支持1个');
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
      },
      handleAppendixBefore(file){
        if(!this.defaultProperties){
          this.$message.warning('附件属性必须选择');
          return false;
        }else {
          if (this.defaultType === 'PICTURE') {
            return this.imgFileCheck(file);
          } else if (this.defaultType === 'WORD') {
            return this.wordFileCheck(file);
          } else if (this.defaultType === 'EXCEL') {
            return this.excelFileCheck(file);
          } else if (this.defaultType === 'PDF') {
            return this.pdfFileCheck(file);
          } else if (this.defaultType === 'PPT') {
            return this.pptFileCheck(file);
          } else if (this.defaultType === 'VEDIO') {
            return this.vedioFileCheck(file);
          } else if (this.defaultType === 'VOICE') {
            return this.voiceFileCheck(file);
          } else {
            return this.otherFileCheck(file);
          }
        }
      },
      handlePreview(file) {
        console.log(file);
      },
      handleAppendixSuccess(response, file, fileList){
        let that = this;
        console.log(response)
        if(response.code == 200) {
          let url = '';
          if(response.data.imgUrl === ''){
            url = response.data.videoUrl;
          }else{
            url = url = response.data.imgUrl;
          }
          updateAppendixInfo({
            appendixAuthority: 'PROTECTED',
            appendixCname: that.appendixPropertiesCname,
            appendixEname: that.defaultProperties,
            appendixUrl: url,
            userType: that.queryTypeText
          }).then((res) => {
            if (res.data.code == 200) {
              that.$notify({
                title: '上传成功',
                type: 'success',
                message: "成功上传文件[" + response.data.fileName + "]",
              });
              setTimeout(function () {
                that.dialogUploadVisible = false;
              }, 1000);
              that.getUserAppendix();
            } else if (res.data.code == 300) {
              that.$notify({
                title: '出现意外',
                type: 'warning',
                message: "上传附件失败[" + res.data.message + "]",
              });
            } else {
              that.$notify({
                title: '系统错误',
                type: 'error',
                message: "系统发生错误[" + res.data.message + "]",
              });
            }
          });
        }else if(response.code == 300){
          that.$notify({
            title: '出现意外',
            type: 'warning',
            message: "上传附件失败[" + response.message + "]",
          });
        }else{
          that.$notify({
            title: '系统错误',
            type: 'error',
            message: "系统发生错误[" + response.message + "]",
          });
        }
      },
      addAppendix() {
        let that = this;
        if(that.appendixCount >= 20){
          this.$notify({
            title: '出现意外',
            type: 'warning',
            message: "附件最大上传数量20个，目前已达到20，请删除无用附件再上传"
          });
          return false;
        }
        if(that.$refs['topUpload']) {
          that.$refs['topUpload'].clearFiles();
        }
        getAppendixConfig().then((res)=>{
          if(res.data.code == 200){
            that.appendixPropertiesOptions = res.data.data;
          }else{
            this.$notify({
              title: '出现意外',
              type: 'warning',
              message: "获取附件属性失败[" + res.data.message + "]",
            });
          }
        });
        this.dialogUploadVisible = true;
      },
      deleteAppendix(fileId, key, key1) {

        let that = this;
        that.$confirm('如果删除审核通过文件将可能会影响到部分功能，确认删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteAppendix(that.$Qs.stringify({
            fileID: fileId
          })).then((res) => {
            if (res.data.code == 200) {
              this.$notify({
                title: '成功',
                type: 'success',
                message: "成功删除",
              });
              that.appendixType[key].data.splice(key1, 1);
            } else if (res.data.code == 300) {
              this.$notify({
                title: '出现意外',
                type: 'warning',
                message: "删除失败[" + res.data.message + "]",
              });
            } else {
              this.$notify({
                title: '系统错误',
                type: 'error',
                message: "系统出现错误[" + res.data.message + "]",
              });
            }
          });
        }).catch(() => {
        });
      },
      changAuth(fileId, nowAuth, targetAuth, key, key1) {
        //改变附件可见性状态
        let that = this;
        if (nowAuth !== targetAuth) {
          changeAppendixAuth(that.$Qs.stringify({
            publicStatus: targetAuth,
            id: fileId
          })).then((res)=>{
            if (res.data.code == 200) {
              this.$notify({
                title: '成功',
                type: 'success',
                message: "已修改附件可见状态",
              });
              this.appendixType[key].data[key1].appendixAuthority = targetAuth;
            } else if (res.data.code == 300) {
              this.$notify({
                title: '出现意外',
                type: 'warning',
                message: "修改状态失败[" + res.data.message + "]",
              });
            } else {
              this.$notify({
                title: '系统错误',
                type: 'error',
                message: "系统出现错误[" + res.data.message + "]",
              });
            }
          });
        }
      },

      getUserAppendix() {
        let that = this;
        getUserAppendix(that.$Qs.stringify({
          userType: that.queryTypeText
        })).then((res) => {
          if (res.data.code == 200) {
            let resData = res.data.data;
            that.appendixType = [];
            that.appendixCount = 0;
            for (let key in resData) {
              if (key === 'PICTURE') {
                let tmpObj = {};
                tmpObj.name = '图片文件';
                tmpObj.type = key;
                tmpObj.data = resData[key];
                that.appendixCount += tmpObj.data.length;
                tmpObj.sortNo = 1;
                that.appendixType.push(tmpObj);
              } else if (key === 'WORD') {
                let tmpObj = {};
                tmpObj.name = 'Word文档';
                tmpObj.type = key;
                tmpObj.data = resData[key];
                that.appendixCount += tmpObj.data.length;
                tmpObj.sortNo = 2;
                that.appendixType.push(tmpObj);
              } else if (key === 'EXCEL') {
                let tmpObj = {};
                tmpObj.name = 'Excel文件';
                tmpObj.type = key;
                tmpObj.data = resData[key];
                that.appendixCount += tmpObj.data.length;
                tmpObj.sortNo = 3;
                that.appendixType.push(tmpObj);
              } else if (key === 'PDF') {
                let tmpObj = {};
                tmpObj.name = 'PDF文件';
                tmpObj.type = key;
                tmpObj.data = resData[key];
                that.appendixCount += tmpObj.data.length;
                tmpObj.sortNo = 4;
                that.appendixType.push(tmpObj);
              } else if (key === 'PPT') {
                let tmpObj = {};
                tmpObj.name = '幻灯片文件';
                tmpObj.type = key;
                tmpObj.data = resData[key];
                that.appendixCount += tmpObj.data.length;
                tmpObj.sortNo = 5;
                that.appendixType.push(tmpObj);
              } else if (key === 'VOICE') {
                let tmpObj = {};
                tmpObj.name = '音频文件';
                tmpObj.type = key;
                tmpObj.data = resData[key];
                that.appendixCount += tmpObj.data.length;
                tmpObj.sortNo = 6;
                that.appendixType.push(tmpObj);
              } else if (key === 'VEDIO') {
                let tmpObj = {};
                tmpObj.name = '视频文件';
                tmpObj.type = key;
                tmpObj.data = resData[key];
                that.appendixCount += tmpObj.data.length;
                tmpObj.sortNo = 7;
                that.appendixType.push(tmpObj);
              } else {
                let tmpObj = {};
                tmpObj.name = '其他文件';
                tmpObj.type = key;
                tmpObj.data = resData[key];
                that.appendixCount += tmpObj.data.length;
                tmpObj.sortNo = 8;
                that.appendixType.push(tmpObj);
              }
            }
            that.appendixType = that.sortBykey(that.appendixType, 'sortNo');
          } else if (res.data.code == 300) {
            that.$notify({
              title: '发生意外',
              type: 'warning',
              message: "获取附件信息出错[" + res.data.message + "]"
            });
          } else {
            that.$notify({
              title: '系统错误',
              type: 'error',
              message: "系统发生错误[未能获取附件信息]"
            });
          }
        })
      }
    }
  }
</script>

<style scoped>
  .upload-top-div{
    height: 50px;
  }
  .topUploadDiv {
    width: 30%;
    border-bottom: #E0E7EB 1px solid;
    position: relative;
    left: 60%;
    top: -40px;
  }

  .item-ul {
    width: 100%;
    border-top: 1px #E0E7EB solid;
    padding: 10px 10px 0px 0px;
  }

  .item-img-ul li {
    list-style: none;
    width: 215px;
    height: 280px;
    margin-left: 10px;
    margin-top: 20px;
    border: #E0E7EB 1px solid;
    border-radius: 6px;
    box-sizing: border-box;
    display: inline-block;
  }

  .item-img-ul li:hover {
    border: #00BCA1 1px solid;
  }

  .item-img-ul li .outDiv {
    position: relative;
    width: 100%;
    height: 280px;
    border-radius: 6px;
  }

  .item-img-ul li .outDiv img {
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }

  .outdiv-imgdiv {
    width: 100%;
    height: 200px;
    position: relative;
    border-bottom: 1px #E0E7EB solid;
    border-radius: 6px;
  }

  .outdiv-imgdiv .out-div-span {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    border-radius: 6px;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s;
  }

  .outdiv-imgdiv .out-div-span:hover {
    opacity: 1;
  }

  .outdiv-imgdiv .out-div-span .out-div-span-view {
    cursor: pointer;
    position: absolute;
    top: 70px;
    left: 40px;
  }

  .outdiv-imgdiv .out-div-span a {
    color: #ffffff;
  }

  .outdiv-imgdiv .out-div-span .out-div-span-view i {
    font-size: 40px;
  }

  .outdiv-imgdiv .out-div-span .out-div-span-delete {
    cursor: pointer;
    position: absolute;
    top: 70px;
    left: 120px;
  }

  .outdiv-imgdiv .out-div-span .out-div-span-delete i {
    font-size: 40px;
  }

  .centerText {
    overflow: hidden;
    text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
    height: 20px;
    display: block;
    position: relative;
    top: 20px;
    font-size: 15px;
    color: #7F8293;
    cursor: default;
    left: 4px;
  }

  .auditLogo {
    position: absolute;
    right: 10px;
    top: 180px;
    transform: rotate(48deg);
    -ms-transform: rotate(48deg); /* Internet Explorer */
    -moz-transform: rotate(48deg); /* Firefox */
    -webkit-transform: rotate(48deg); /* Safari 和 Chrome */
    -o-transform: rotate(48deg); /* Opera */
  }

  .auditLogo i {
    color: #9a6e3a;
    font-size: 70px;
  }

  .auditingLogo {
    position: absolute;
    right: 0px;
    top: 170px;
    transform: rotate(48deg);
    -ms-transform: rotate(48deg); /* Internet Explorer */
    -moz-transform: rotate(48deg); /* Firefox */
    -webkit-transform: rotate(48deg); /* Safari 和 Chrome */
    -o-transform: rotate(48deg); /* Opera */
  }

  .auditingLogo i {
    color: #0086b3;
    font-size: 88px;
  }

  .auditedLogo {
    position: absolute;
    right: 0px;
    top: 170px;
    transform: rotate(48deg);
    -ms-transform: rotate(48deg); /* Internet Explorer */
    -moz-transform: rotate(48deg); /* Firefox */
    -webkit-transform: rotate(48deg); /* Safari 和 Chrome */
    -o-transform: rotate(48deg); /* Opera */
  }

  .auditedLogo i {
    color: #00BCA1;
    font-size: 88px;
  }

  .rejectLogo {
    position: absolute;
    right: 0px;
    top: 170px;
    transform: rotate(48deg);
    -ms-transform: rotate(48deg); /* Internet Explorer */
    -moz-transform: rotate(48deg); /* Firefox */
    -webkit-transform: rotate(48deg); /* Safari 和 Chrome */
    -o-transform: rotate(48deg); /* Opera */
  }

  .rejectLogo i {
    color: #dd2f45;
    font-size: 88px;
  }

  .authOpreat {
    display: block;
    position: relative;
    top: 30px;
    left: 5px;
  }

  .authOpreat i {
    margin-left: 12px;
    color: #7F8293;
    cursor: pointer;
  }

  .authOpreat .public {
    color: #00BCA1;
  }

  .svgClass {
    width: 100%;
    margin-top: 5px;
    height: 185px;
  }

  .svgExcelClass {
    width: 100%;
    margin-top: 5px;
    height: 185px;
    fill: #036e22;
  }


</style>
<style>
  .list-item {
    display: inline-block;
    margin-right: 10px;
  }

  .list-enter-active, .list-leave-active {
    transition: all 1s;
  }

  .list-enter, .list-leave-to
    /* .list-leave-active for below version 2.1.8 */
  {
    opacity: 0;
    transform: translateY(30px);
  }

  .list-move {
    transition: all 1s ease;
  }

  .list-leave-active {
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserAppendix.vue